import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import PropTypes from 'prop-types';

import './Staff.scss';
import { getStaffPhoto } from '../../Context/StaffPhoto';
import Button from '../Button/Button';
import Pages from '../../Context/Pages';

class Staff extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    const { name, role, email, isInteractable } = this.props;
    const firstName = name.split(' ')[0];

    return (
      <div className='staff-container'>
        <img className='staff-image no-select' src={getStaffPhoto(name)} alt='' />
        <span className='staff-name'>{name}</span>
        <span className='staff-role'>{role}</span>
        {email && <span className='staff-email'>{email}</span>}
        {isInteractable &&
          <Button page={Pages.Individual[name]}>
            View {firstName}'s Profile
          </Button>
        }
      </div>
    );
  }
}

Staff.propTypes = {
  name: PropTypes.oneOf(['Terry Grainger', 'Ingrid de Chélard', 'Tee Duong', 'Helen Potter', 'Matthew Grainger']).isRequired,
  role: PropTypes.string.isRequired,
  email: PropTypes.string,
  isInteractable: PropTypes.bool
};

Staff.defaultProps = {
  email: null,
  isInteractable: true
}

Staff.contextType = GraingerAccountContext;
export default Staff;